import { render, staticRenderFns } from "./BackendLogin.vue?vue&type=template&id=bbc39c92&lang=pug"
import script from "./BackendLogin.vue?vue&type=script&lang=js"
export * from "./BackendLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports